<template>
  <div class="cart__donations" v-if="donation">
    <h4 class="cart__donations-title">{{ donation.heading }}</h4>
    <p>{{ donation.subheading }}</p>
    <button
      class="cart__donations-button btn btn--secondary btn--full"
      :class="{ 'active': variantSelected && variantSelected.id == variant.id }"
      v-for="variant in donation.variants"
      :key="variant.id"
      @click.prevent="createDonation(variant)"
      :disabled="updating || variantSelected">
      DONATE {{ variant.public_title }}
    </button>
    <div class="cart__donations-footer" v-if="variantSelected">
      <button
        class="btn--small"
        @click.prevent="removeDonation()">
        undo
      </button>
      <small>
        You donate <strong>{{ $money(variantSelected.price) }}</strong>
      </small>
    </div>
  </div>
</template>

<script>
import { getState, addItem, updateItemQuantityById } from 'scripts/utils/cart'

export default {
  name: 'Donations',

  data () {
    return {
      donation: null,
      cartItems: null,
      variantSelected: null,
      updating: false
    }
  },

  mounted () {
    getState().then(state => {
      this.cartItems = [ ...state.items ]
      this.variantSelected = this.cartItems.find(item => item.properties && item.properties._donation)
    })

    fetch(`/collections/all?view=cart`)
      .then(res => res.json()).then(data => {
        if (data.length) {
          this.donation = JSON.parse(data).donation
        }
      })
  },

  methods: {
    createDonation (variant) {
      this.updating = true
      addItem(variant.id, { properties: { '_hide': true, '_donation': true } })
        .then(() => {
          this.updating = false
          this.variantSelected = variant
          window.PSTheme.Vue.Header.updateCartCount(1)
          this.$emit('donationUpdated')
        })
    },

    removeDonation () {
      updateItemQuantityById(this.variantSelected.id, 0)
        .then(() => {
          this.variantSelected = null
          window.PSTheme.Vue.Header.updateCartCount(-1)
          this.$emit('donationUpdated')
        })
    }
  }
}
</script>

<style>
  .cart__donations-title {
    margin-bottom: .35rem;
  }
  
  .cart__donations-button {
    margin-top: .75rem;
  }

  .cart__donations-button.active {
    background: var(--blush);
  }

  .cart__donations-footer {
    padding-top    : .5rem;
    display        : flex;
    justify-content: space-between;
    align-items    : center;
  }
</style>
